<eda-dialog2 [display]="display" [header]="title" width="60vw" height="80vh" [overflow]="'auto'"
  (close)="closeDialog()">

  <div content class="p-2 space-y-6">
    <h5 i18n="@@rolesPermisos">Roles y permisos de fila</h5>
    <eda-table style="margin-top: 3em;" [inject]="securityTable"></eda-table>
    <h5 i18n="@@rolesPermisosTabla">Visibilidad de tablas</h5>
    <eda-table style="margin-top: 3em;" [inject]="securityTableTableLevel"></eda-table>
    <h5 i18n="@@rolesPermisosModelo">Visibilidad a nivel de modelo</h5>
    <eda-table style="margin-top: 3em;" [inject]="securityModelTableLevel"></eda-table>
  </div>

</eda-dialog2>
